import { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ARTICLES, findArticle } from '../articles';
import { GameLinks } from '../components/GameLinks';
import { formatDay } from '../games/fresh';
import { setPageMeta } from '../lib/seo';
import { NotFound } from './NotFound';

export const GUIDES_TITLE = 'Game Guides and Lists · SuperFunUBG';
export const GUIDES_DESCRIPTION = 'Strategy guides and hand-picked lists of free browser games: two-player games, quick games for a break, survival games and more.';

/** /guides: every article, newest first. */
export function GuidesPage() {
  useEffect(() => {
    setPageMeta(GUIDES_TITLE, GUIDES_DESCRIPTION, '/guides');
  }, []);
  return (
    <main id="main" className="legal">
      <div className="band band--hero legal__hero">
        <div>
          <h1 className="hero__title">Game Guides</h1>
          <p className="legal__date">Strategy guides and hand-picked lists, written by the people who make the games</p>
        </div>
      </div>
      <ul className="article-list">
        {ARTICLES.map((a) => (
          <li key={a.slug}>
            <Link to={`/guides/${a.slug}`}>
              <h2>{a.title}</h2>
              <p>{a.description}</p>
              <span className="article-list__date">Updated {formatDay(a.updated)}</span>
            </Link>
          </li>
        ))}
      </ul>
    </main>
  );
}

/** /guides/<slug>: one article. */
export function ArticlePage() {
  const article = findArticle(useParams().slug ?? '');
  useEffect(() => {
    if (article) setPageMeta(`${article.title} · SuperFunUBG`, article.description, `/guides/${article.slug}`);
  }, [article]);
  if (!article) return <NotFound />;
  return (
    <main id="main" className="legal">
      <div className="band band--hero legal__hero">
        <div>
          <nav className="crumbs" aria-label="Breadcrumb">
            <ol>
              <li>
                <Link to="/guides">Guides</Link>
              </li>
              <li aria-current="page">{article.title}</li>
            </ol>
          </nav>
          <h1 className="hero__title hero__title--article">{article.title}</h1>
          <p className="legal__date">
            By the SuperFun team · Updated {formatDay(article.updated)}
          </p>
        </div>
      </div>
      <article className="legal__body article">
        {article.intro.map((p) => (
          <p key={p}>{p}</p>
        ))}
        {article.sections.map((s) => (
          <section key={s.heading}>
            <h2>{s.heading}</h2>
            {s.paragraphs.map((p) => (
              <p key={p}>{p}</p>
            ))}
            {s.games && <GameLinks ids={s.games} />}
          </section>
        ))}
      </article>
      <nav className="legal__nav" aria-label="More">
        <Link to="/guides">More guides</Link>
        <Link to="/">All games</Link>
      </nav>
    </main>
  );
}
